
import { nodeHelpers } from '@/components/mixins/nodeHelpers';

import AliareInput from '@/components/AliareInput.vue';
import mixins from 'vue-typed-mixins';

export default mixins(
	nodeHelpers,
).extend({
	components: {
		AliareInput,
	},
	props: {
		dataInput: {
			type: Object,
		},
		initialValue: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			isLoadingDataCenter: false,
			dataCenterSelected: '',
			dataCenterList: [],
			oldSearch: '',
			projectSelected: '',
			showSelect: false,
			searchDataCenter: '',
		};
	},
	computed: {
		isEdit() {
			if (this.dataInput.item?.workflow?.id) {
				return true;
			} else {
				return;
			}
		},
		workspace() {
			return this.$store.getters.workspace;
		},
	},
	watch: {
		initialValue: {
			immediate: true,
			handler(newVal) {
				if (newVal && newVal.id && newVal.titulo) {
					this.dataCenterSelected = newVal;
				} else {
					this.dataCenterSelected = '';
				}
			},
		},
	},
	async mounted() {
		if (!this.dataCenterList.length) {
			try {
				this.isLoadingDataCenter = true;
				const list = await this.restApi().getDataCenter(this.workspace.id, {
					searchTitulo: '',
					ativo: true,
				});
				this.dataCenterList = list;
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoadingDataCenter = false;
			}
		}
	},
	methods: {
		disableInput() {
			this.showSelect = false;
		},

		searchInfoByName:
		_.debounce(async function (e)  {
			let firstFocus = false;
			this.isLoadingDataCenter = true;

			if (!this.dataCenterList.length) {
				firstFocus = true;
			}

			if (firstFocus || this.searchDataCenter.length > 2 && this.oldSearch !== this.searchDataCenter || !firstFocus && this.searchDataCenter.length < 2 && this.oldSearch !== this.searchDataCenter) {
				try {
					const list = await this.restApi().getDataCenter(this.workspace.id, {
						searchTitulo: this.searchDataCenter,
						ativo: true,
					});

					this.dataCenterList = list;

					this.oldSearch = JSON.parse(JSON.stringify(this.searchDataCenter));

				} catch (e) {
					console.log(e);
				}
			}

			this.isLoadingDataCenter = false;
		}, 500),
		activeSearch() {
			this.showSelect = !this.showSelect;
			this.$nextTick(() => {
				this.$refs.aliareInput.$refs.input.focus();
			});
		},
		selectedDataCenter(info) {
			this.showSelect = !this.showSelect;
			this.dataCenterSelected = info;
			let dataItem;
			if (this.dataInput) {
				dataItem = JSON.parse(JSON.stringify(this.dataInput));
			}

			this.$emit('selected', {data: info, item: dataItem});
		},

	},

});
